import { styled } from '@mui/material/styles';
import { StyHRPage } from 'routes/HumanResourcesModule/components/ui/StyTabulatedChips';

const StyHome = styled(StyHRPage, {
    name: 'StyHome',
})({
    display: 'flex',
    flexDirection: 'column',
    gap: '2em',
    margin: '0 26px',
    padding: '16px 0 16px 0',
});

export default StyHome;
